const GradeStatus = {
    0: 'A',
    1: 'B',
    2: 'C'
};

export default GradeStatus;
